import { render, staticRenderFns } from "./QuoteFormStep1.vue?vue&type=template&id=12127d6c&"
import script from "./QuoteFormStep1.vue?vue&type=script&lang=js&"
export * from "./QuoteFormStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports